"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcFormLayout = void 0;
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AcFormFieldErrorMessage_1 = require("./AcFormFieldErrorMessage");
var AcFormFieldLabel_1 = require("./AcFormFieldLabel");
var AcFormAppend_1 = require("./AcFormAppend");
var AcFormPrepend_1 = require("./AcFormPrepend");
// Layout for the AC Form
var AcFormLayout = function (_a) {
    var invalid = _a.invalid, errorId = _a.errorId, hideLabel = _a.hideLabel, label = _a.label, tooltip = _a.tooltip, labelClassName = _a.labelClassName, readOnly = _a.readOnly, required = _a.required, forceHideRequiredLabel = _a.forceHideRequiredLabel, prependIcon = _a.prependIcon, appendIcon = _a.appendIcon, formControl = _a.formControl, type = _a.type, children = _a.children, fieldName = _a.fieldName, value = _a.value, size = _a.size, clearable = _a.clearable, onClick = _a.onClick, onChange = _a.onChange;
    var hasPrepend = prependIcon;
    var hasAppend = appendIcon || required;
    var onFormClick = function () {
        if (onClick) {
            onClick(fieldName, value);
        }
    };
    var onFormClear = function () {
        onChange === null || onChange === void 0 ? void 0 : onChange(fieldName, '');
    };
    return (
    // fix for IE to set width correctly
    react_1.default.createElement("div", { style: { flex: '1 1 100%' } },
        react_1.default.createElement(react_bootstrap_1.Form.Group, { className: clsx_1.default({
                'form-validation-error': invalid && errorId,
            }) },
            !hideLabel && (react_1.default.createElement(AcFormFieldLabel_1.AcFormFieldLabel, { label: label, tooltip: tooltip, className: labelClassName, readOnly: readOnly, required: required && !readOnly && !forceHideRequiredLabel, type: type })),
            react_1.default.createElement("div", { className: "position-relative" },
                hasPrepend && (react_1.default.createElement(AcFormPrepend_1.AcFormPrepend, { prepend: prependIcon, size: size, type: type, onIconClick: onFormClick })),
                formControl,
                hasAppend && (react_1.default.createElement(AcFormAppend_1.AcFormAppend, { required: required, append: appendIcon, size: size, type: type, readOnly: readOnly, onIconClick: onFormClick, onClearClick: clearable && value && (value === null || value === void 0 ? void 0 : value.length) > 0 ? onFormClear : undefined }))),
            children,
            invalid && errorId && !readOnly && react_1.default.createElement(AcFormFieldErrorMessage_1.AcFormFieldErrorMessage, { messageId: errorId }))));
};
exports.AcFormLayout = AcFormLayout;
exports.AcFormLayout.displayName = 'AcFormLayout';
//# sourceMappingURL=AcFormLayout.js.map